import { Center, ModalBody, Spinner, Text } from '@chakra-ui/react'

export const ProcessingStep = () => (
  <ModalBody p={0}>
    <Center flexDirection='column' minH='400px'>
      <Text fontSize='xl' fontWeight='bold' mb={6}>
        Calculating Grid Accuracy Results
      </Text>
      <Spinner
        color='#298bbd'
        emptyColor='gray.300'
        mb={6}
        size='xl'
        thickness='4px'
      />
      <Text color='gray.600' fontSize='md'>
        This may take a few minutes. Do not leave this screen
      </Text>
    </Center>
  </ModalBody>
)
